import { AppMeituan, AppDianping, AppWaimai } from '../Icon';

export const getIcon = (item: any) => {
  const { app } = item;
  if (app === 'meituan') {
    return <AppMeituan />;
  }
  if (app === 'dianping') {
    return <AppDianping />;
  }
  if (app === 'waimai') {
    return <AppWaimai />;
  }
  return false;
};
